// extracted by mini-css-extract-plugin
export default {"wrapper":"CodeBlock_wrapper__dgWFc"};